module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center1 f20"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j0",
    staticStyle: {
      "margin-top": "1.0em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j0"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. In the Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Blues Finds a Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Keeping the Blues Alive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Getting Back to Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Blues Today")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/last",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggested Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d989bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/content.vue
// module id = 63
// module chunks = 0